'use strict';

require('lodash');
require('ajv');
var entityKindSchemaValidator = require('../validation/entityKindSchemaValidator.cjs.js');
require('../validation/makeValidator.cjs.js');

function ajvCompiledJsonSchemaValidator(schema) {
  let validator;
  return {
    async check(data) {
      if (!validator) {
        validator = entityKindSchemaValidator.entityKindSchemaValidator(schema);
      }
      return validator(data) === data;
    }
  };
}

exports.ajvCompiledJsonSchemaValidator = ajvCompiledJsonSchemaValidator;
//# sourceMappingURL=util.cjs.js.map
